import api from '@/services/api';
import type { PaginatedResponse } from '@/types/api';
import type { Lead, LeadStatus, ConvertLeadResponse } from '@/types/lead';

const BASE_PATH = '/leads';

/**
 * Lead management API service (admin).
 */
export const leadService = {
  /**
   * Lists leads with pagination and optional filters.
   */
  async getLeads(params?: {
    page?: number;
    limit?: number;
    status?: LeadStatus;
    campaignId?: string;
    origin?: string;
  }): Promise<PaginatedResponse<Lead>> {
    const { data } = await api.get<PaginatedResponse<Lead>>(BASE_PATH, { params });
    return data;
  },

  /**
   * Gets a lead by its identifier.
   */
  async getLeadById(id: string): Promise<Lead> {
    const { data } = await api.get<Lead>(`${BASE_PATH}/${id}`);
    return data;
  },

  /**
   * Marks a lead as contacted.
   */
  async markContacted(id: string): Promise<Lead> {
    const { data } = await api.put<Lead>(`${BASE_PATH}/${id}/contact`);
    return data;
  },

  /**
   * Creates an invitation for a lead (convert action).
   */
  async convertLead(id: string): Promise<ConvertLeadResponse> {
    const { data } = await api.post<ConvertLeadResponse>(`${BASE_PATH}/${id}/convert`);
    return data;
  },

  /**
   * Marks a lead as lost.
   */
  async markLost(id: string): Promise<Lead> {
    const { data } = await api.put<Lead>(`${BASE_PATH}/${id}/lost`);
    return data;
  },
};
